module.exports = __webpack_public_path__ + "static/1-8891c7280849a384af10d73d8fb20611.jpg";